import { Fragment } from 'react';
import { Box, Stack } from '@mui/material';
import { ControlledInputs } from '@/components';
import { useResetPasswordFormContext } from '../hooks';

export const ResetPasswordFormFields = () => {
  const form = useResetPasswordFormContext();
  return (
    <Fragment>
      <Box display="flex" justifyContent="center">
        <Stack spacing={2} sx={{ width: 280 }}>
          <ControlledInputs.PasswordField
            placeholder="New Password"
            ControllerProps={{
              control: form.control,
              name: 'password',
            }}
          />
          <ControlledInputs.PasswordField
            placeholder="Confirm Password"
            ControllerProps={{
              control: form.control,
              name: 'confirmPassword',
            }}
          />
        </Stack>
      </Box>
    </Fragment>
  );
};